import { SearchInput as HammerSearchInput } from '@liveauctioneers/hammer-ui-core/searchInput';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

type Props = {
    /** Used for accesibility */
    readonly 'aria-label': string;
    /** Boolean set true when data is loading */
    readonly loading: boolean;
    /** Callback function called when text is typed into the search field */
    readonly onSearch: Function;
    /** Add custom testid */
    testid?: string;
};

const SearchInput = ({
    'aria-label': ariaLabel = 'Search Input',
    loading,
    onSearch,
    testid = 'searchInput',
}: Props) => {
    const query = useQuery();
    const search = query.get('search');
    const [searchQuery, setSearchQuery] = React.useState(search || '');

    const handleFilterChanged = (value: string) => {
        // remove multiple consecutive spaces
        const cleanedValue = value.replace(/ +(?= )/g, '');

        // remove any remaining spaces if there are only spaces
        if (!value.trim()) {
            setSearchQuery('');
        }

        setSearchQuery(cleanedValue);
    };

    const handleSubmit = () => {
        onSearch(searchQuery);
    };

    const handleClearFilter = () => {
        setSearchQuery('');
        onSearch('');
    };

    return (
        <HammerSearchInput
            aria-label={ariaLabel}
            className="mb-sm"
            data-testid={testid}
            disabled={loading}
            onClear={handleClearFilter}
            onSubmit={handleSubmit}
            onTextChange={handleFilterChanged}
            placeholder="Search all messages"
            value={searchQuery}
        />
    );
};

export default SearchInput;
